import { gql } from "@apollo/client";

export const GET_ARCHIVOS_VISITA = gql`
  query archivoVisitasById($idVisita: Int!) {
    archivoVisitasById(idVisita: $idVisita) {
      valorEsperado{
          idArchivo
          idTipoArchivoDocumento
          titulo
          extension
          archivo
        }
      }
    }
`;